<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        企业自评表
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- content -->
    <section class="content-section">
      <self-assessment-form-detail
        pageType="edit"
        ref="editSelfAssessmentForm"
      ></self-assessment-form-detail>
    </section>
  </div>
</template>

<script>
// components
import selfAssessmentFormDetail from "./components/selfAssessmentFormDetail.vue";
// api
import { getAppraisalCompanyInfo } from "@/api/businessApplication";
export default {
  components: { selfAssessmentFormDetail },
  data() {
    return {
      loading: false,
      detailData: {},
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页",
          },
        },
        {
          path: "/companySelfAssessmentFrom",
          isRedirect: true,
          meta: {
            title: "企业自评表单",
          },
        },
        {
          path: "/companySelfAssessmentFromDetail",
          isRedirect: true,
          meta: {
            title: "企业自评表单填写",
          },
        },
      ],
    };
  },
  created() {
    this.getDetailById();
  },
  mounted() {},
  methods: {
    // 查询详情数据
    async getDetailById() {
      try {
        let res = await getAppraisalCompanyInfo({
          companyAppraisalSelfId: this.$route.query.companyAppraisalSelfId,
        });
        if (res.code) {
          this.$refs.editSelfAssessmentForm.init(res.result);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  margin: 0 20px;
  height: calc(100% - 54px);
  overflow: auto;
  background: #fff;
}
</style>
